var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.contact.length)?_c('div',{staticClass:"d-flex flex-column contact-widget"},_vm._l((_vm.contact),function(ref,i){
var link = ref.link;
var icon = ref.icon;
var target = ref.target;
var size = ref.size;
var text = ref.text;
return _c('div',{key:i,staticClass:"mb-2 mb-md-0"},[_c('v-btn',{staticClass:"text-none",attrs:{"href":link,"target":target,"text":""}},[_c('v-icon',{attrs:{"color":"primary","size":size,"left":""}},[_vm._v(" "+_vm._s(icon)+" ")]),_c('span',[_vm._v(_vm._s(text))])],1)],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }